@use 'vars';

$audio-player-height: 30px;
$audio-player-max-width: 300px;

.audio-player {
  height: $audio-player-height;
  width: 100%;
  max-width: $audio-player-max-width;
  min-width: 0;

  // Ensures the inner media element grows to full parent width. Sometimes this enclosure is smaller than the audio element width
  &::-webkit-media-controls-enclosure {
    max-width: 100%;
  }

  &::-webkit-media-controls-panel {
    background-color: vars.$mid-grey;
  }
}
